import { PaymentReportColumnNames, PaymentReportColumnSelectors } from '../enums';
import { IColumnSelection } from '../types';

export const initialDisbursementsColumnsSelection: IColumnSelection[] = [
  {
    name: PaymentReportColumnNames.Created,
    selector: PaymentReportColumnSelectors.Created,
    sortable: true,
    omit: false,
  },
  {
    name: PaymentReportColumnNames.ArrivalDate,
    selector: PaymentReportColumnSelectors.ArrivalDate,
    sortable: true,
    omit: false,
  },
  {
    name: PaymentReportColumnNames.Amount,
    selector: PaymentReportColumnSelectors.Amount,
    sortable: true,
    omit: false,
    width: '155px',
    right: true,
  },
  {
    name: PaymentReportColumnNames.PaymentStatus,
    selector: PaymentReportColumnSelectors.PaymentStatus,
    sortable: true,
    omit: false,
    width: '140px',
  },
  {
    name: PaymentReportColumnNames.LinkedTransactions,
    selector: PaymentReportColumnSelectors.LinkedTransactions,
    sortable: false,
    omit: false,
  },
];
